export function calculateMolecularWeightAndConcentration(obj, key) {
  const mw = isPositiveFloat(obj.molecularWeight);
  const mgmL = isPositiveFloat(obj.concentrationmgmL);
  if (mw && mgmL) {
    obj.concentrationmM =
      obj.molecularWeight > 0
        ? (parseFloat(obj.concentrationmgmL) / parseFloat(obj.molecularWeight)).toFixed(3)
        : 0;
  }
  return obj;
}

export function isPositiveFloat(d) {
  if (parseFloat(d) >= 0) {
    return true;
  }
  return false;
}
